import BaseClient from '@/app/model/api/response/baseApiClient'

class VarietyDeleteApi extends BaseClient {
  public doVarietyDelete (id: string) {
    const path: string = '/v1/master/varieties/' + id

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'DELETE')
  }
}

export default new VarietyDeleteApi()
